import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../core/data/routes/all_routes';

const PasswordRecovery = () => {
  const routes = all_routes;
  return (
    <>
      <div className="content" style={{height: 'calc(100vh - 85px)', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
        <div className="container">
          <div className="row">
            {/* Password Recovery */}
            <div className="col-md-6 col-lg-6 mx-auto">
              <div className="login-wrap">
                <div className="login-header">
                  <h3>Şifremi Unuttum</h3>
                  <p>
                    Lütfen email adresinizi giriniz ve şifrenizi sıfırlamak için bir link gönderilecektir.
                  </p>
                </div>
                <form action={routes.resetPassword}>
                  <div className="log-form">
                    <div className="form-group">
                      <label className="col-form-label">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="johndoe@example.com"
                      />
                    </div>
                  </div>
                  <Link to={routes.resetPassword}
                    className="btn btn-primary w-100 login-btn"
                    type="submit"
                  >
                    Gönder
                  </Link>
                  <p className="no-acc mt-0">
                    Şifreni hatırlıyor musun ? <Link to={'/auth/login'}>Giriş Yap</Link>
                  </p>
                </form>
              </div>
            </div>
            {/* /Password Recovery */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordRecovery;
